import React from 'react'
import type { Icon } from 'shared/utils'

const Filter = (props: Icon) => {
    const { color = 'white', size = 24, className = 'filter' } = props
    return (
        <svg className={className} width={size} height={size}>
            <path
                fill={color}
                d="M4.694 7.472h2.084v.695a1.389 1.389 0 0 0 2.778 0V5.389a1.389 1.389 0 1 0-2.778 0v.694H4.694a.694.694 0 1 0 0 1.39zm0 5.556h9.028v-1.39H4.694a.694.694 0 1 0 0 1.39zm15.973-6.25a.694.694 0 0 0-.695-.695h-9.028v1.39h9.028a.695.695 0 0 0 .695-.695zM4 17.888c0 .384.31.695.694.695h3.473v-1.389H4.694A.694.694 0 0 0 4 17.89zm15.972-6.25H17.89v-.694a1.389 1.389 0 0 0-2.778 0v2.778a1.389 1.389 0 0 0 2.778 0v-.694h2.083a.694.694 0 1 0 0-1.39zm0 5.556h-7.639V16.5a1.389 1.389 0 1 0-2.777 0v2.778a1.389 1.389 0 0 0 2.777 0v-.695h7.64a.694.694 0 1 0 0-1.389z"
            />
        </svg>
    )
}

export { Filter }
